export default "__VITE_ASSET__BkOgVati__"